import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './LanguageContext';
import Header from './components/Header';
import Home from './components/Home';
import RSVP from './components/RSVP';
import VenueMap from './components/VenueMap';
import Registry from './components/Registry';

const App: React.FC = () => {
    return (
        <LanguageProvider>
            <Router>
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/rsvp" element={<RSVP />} />
                        <Route path="/wishlist" element={<Registry />} />
                        <Route path="/venue" element={<VenueMap />} />
                    </Routes>
                </main>
            </Router>
        </LanguageProvider>
    );
};

export default App;